/**
 * Demo Mode Data
 * 
 * Pre-loaded, realistic data for no-login demo experience.
 * Shows the full Carted value prop without friction.
 */

// This week's pre-loaded meal plan
export const DEMO_MEAL_PLAN = {
  id: "demo-plan-001",
  name: "This Week's Plan",
  path_id: "weeknight-healthy",
  path_name: "Weeknight Healthy",
  created_at: new Date().toISOString(),
  servings: 4,
  days: [
    {
      name: "Monday",
      meals: [
        {
          id: "demo-meal-1",
          recipe_id: "demo-recipe-1",
          recipe_title: "Lemon Herb Chicken with Roasted Vegetables",
          recipe_image: "https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?w=400",
          servings: 4,
          prep_time: 15,
          cook_time: 35,
          price_estimate: 12.50,
          health_labels: ["high-protein", "low-carb"],
          ingredients: [
            { name: "chicken breast", amount: 1.5, unit: "lbs" },
            { name: "lemon", amount: 2, unit: "" },
            { name: "garlic", amount: 4, unit: "cloves" },
            { name: "rosemary", amount: 2, unit: "sprigs" },
            { name: "broccoli", amount: 2, unit: "cups" },
            { name: "carrots", amount: 3, unit: "" },
            { name: "olive oil", amount: 3, unit: "tbsp" }
          ]
        }
      ]
    },
    {
      name: "Tuesday",
      meals: [
        {
          id: "demo-meal-2",
          recipe_id: "demo-recipe-2",
          recipe_title: "Sheet Pan Salmon with Asparagus",
          recipe_image: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400",
          servings: 4,
          prep_time: 10,
          cook_time: 20,
          price_estimate: 18.75,
          health_labels: ["high-protein", "omega-3"],
          ingredients: [
            { name: "salmon fillet", amount: 1.5, unit: "lbs" },
            { name: "asparagus", amount: 1, unit: "bunch" },
            { name: "lemon", amount: 1, unit: "" },
            { name: "garlic", amount: 3, unit: "cloves" },
            { name: "olive oil", amount: 2, unit: "tbsp" },
            { name: "dill", amount: 2, unit: "tbsp" }
          ]
        }
      ]
    },
    {
      name: "Wednesday",
      meals: [
        {
          id: "demo-meal-3",
          recipe_id: "demo-recipe-3",
          recipe_title: "Turkey Taco Bowls",
          recipe_image: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400",
          servings: 4,
          prep_time: 15,
          cook_time: 20,
          price_estimate: 11.25,
          health_labels: ["high-protein", "balanced"],
          ingredients: [
            { name: "ground turkey", amount: 1.25, unit: "lbs" },
            { name: "black beans", amount: 1, unit: "can" },
            { name: "rice", amount: 1.5, unit: "cups" },
            { name: "bell pepper", amount: 2, unit: "" },
            { name: "avocado", amount: 2, unit: "" },
            { name: "lime", amount: 2, unit: "" },
            { name: "taco seasoning", amount: 1, unit: "packet" }
          ]
        }
      ]
    },
    {
      name: "Thursday",
      meals: [
        {
          id: "demo-meal-4",
          recipe_id: "demo-recipe-4",
          recipe_title: "Garlic Butter Shrimp Pasta",
          recipe_image: "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=400",
          servings: 4,
          prep_time: 10,
          cook_time: 15,
          price_estimate: 14.50,
          health_labels: ["quick-meal"],
          ingredients: [
            { name: "shrimp", amount: 1, unit: "lb" },
            { name: "linguine", amount: 1, unit: "lb" },
            { name: "garlic", amount: 6, unit: "cloves" },
            { name: "butter", amount: 4, unit: "tbsp" },
            { name: "parsley", amount: 0.25, unit: "cup" },
            { name: "parmesan", amount: 0.5, unit: "cup" },
            { name: "white wine", amount: 0.5, unit: "cup" }
          ]
        }
      ]
    },
    {
      name: "Friday",
      meals: [
        {
          id: "demo-meal-5",
          recipe_id: "demo-recipe-5",
          recipe_title: "BBQ Chicken Pizza (Homemade)",
          recipe_image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400",
          servings: 4,
          prep_time: 20,
          cook_time: 15,
          price_estimate: 9.75,
          health_labels: ["family-friendly"],
          ingredients: [
            { name: "pizza dough", amount: 1, unit: "lb" },
            { name: "chicken breast", amount: 0.75, unit: "lbs" },
            { name: "bbq sauce", amount: 0.5, unit: "cup" },
            { name: "red onion", amount: 0.5, unit: "" },
            { name: "mozzarella", amount: 2, unit: "cups" },
            { name: "cilantro", amount: 2, unit: "tbsp" }
          ]
        }
      ]
    },
    {
      name: "Saturday",
      meals: []
    },
    {
      name: "Sunday",
      meals: [
        {
          id: "demo-meal-6",
          recipe_id: "demo-recipe-6",
          recipe_title: "Slow Cooker Pot Roast",
          recipe_image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
          servings: 6,
          prep_time: 20,
          cook_time: 480,
          price_estimate: 22.00,
          health_labels: ["meal-prep", "high-protein"],
          ingredients: [
            { name: "chuck roast", amount: 3, unit: "lbs" },
            { name: "potatoes", amount: 2, unit: "lbs" },
            { name: "carrots", amount: 1, unit: "lb" },
            { name: "onion", amount: 1, unit: "large" },
            { name: "beef broth", amount: 2, unit: "cups" },
            { name: "thyme", amount: 4, unit: "sprigs" },
            { name: "garlic", amount: 4, unit: "cloves" }
          ]
        }
      ]
    }
  ]
};

// Pre-calculated grocery list from the meal plan
export const DEMO_GROCERY_LIST = {
  id: "demo-list-001",
  name: "Weekly Groceries",
  created_at: new Date().toISOString(),
  meal_plan_id: "demo-plan-001",
  items: [
    // Proteins
    { name: "Chicken Breast", amount: 2.25, unit: "lbs", aisle: "Meat & Seafood", price: 8.99, checked: false },
    { name: "Salmon Fillet", amount: 1.5, unit: "lbs", aisle: "Meat & Seafood", price: 14.99, checked: false },
    { name: "Ground Turkey", amount: 1.25, unit: "lbs", aisle: "Meat & Seafood", price: 6.49, checked: false },
    { name: "Shrimp", amount: 1, unit: "lb", aisle: "Meat & Seafood", price: 9.99, checked: false },
    { name: "Chuck Roast", amount: 3, unit: "lbs", aisle: "Meat & Seafood", price: 18.99, checked: false },
    
    // Produce
    { name: "Lemons", amount: 3, unit: "", aisle: "Produce", price: 1.50, checked: false },
    { name: "Limes", amount: 2, unit: "", aisle: "Produce", price: 0.80, checked: false },
    { name: "Garlic", amount: 2, unit: "heads", aisle: "Produce", price: 1.00, checked: false },
    { name: "Broccoli", amount: 2, unit: "cups", aisle: "Produce", price: 2.99, checked: false },
    { name: "Carrots", amount: 1.5, unit: "lbs", aisle: "Produce", price: 2.49, checked: false },
    { name: "Asparagus", amount: 1, unit: "bunch", aisle: "Produce", price: 3.99, checked: false },
    { name: "Bell Peppers", amount: 2, unit: "", aisle: "Produce", price: 2.00, checked: false },
    { name: "Avocados", amount: 2, unit: "", aisle: "Produce", price: 3.00, checked: false },
    { name: "Red Onion", amount: 1, unit: "", aisle: "Produce", price: 0.75, checked: false },
    { name: "Yellow Onion", amount: 1, unit: "large", aisle: "Produce", price: 0.50, checked: false },
    { name: "Potatoes", amount: 2, unit: "lbs", aisle: "Produce", price: 3.49, checked: false },
    
    // Dairy
    { name: "Butter", amount: 1, unit: "stick", aisle: "Dairy", price: 1.50, checked: false },
    { name: "Parmesan Cheese", amount: 0.5, unit: "cup", aisle: "Dairy", price: 4.99, checked: false },
    { name: "Mozzarella Cheese", amount: 2, unit: "cups", aisle: "Dairy", price: 4.49, checked: false },
    
    // Pantry
    { name: "Olive Oil", amount: 1, unit: "bottle", aisle: "Pantry", price: 0, checked: true, note: "Pantry staple" },
    { name: "Black Beans", amount: 1, unit: "can", aisle: "Pantry", price: 1.29, checked: false },
    { name: "Rice", amount: 1.5, unit: "cups", aisle: "Pantry", price: 0, checked: true, note: "Pantry staple" },
    { name: "Linguine", amount: 1, unit: "lb", aisle: "Pantry", price: 1.99, checked: false },
    { name: "Pizza Dough", amount: 1, unit: "lb", aisle: "Bakery", price: 3.49, checked: false },
    { name: "BBQ Sauce", amount: 1, unit: "bottle", aisle: "Pantry", price: 3.49, checked: false },
    { name: "Taco Seasoning", amount: 1, unit: "packet", aisle: "Pantry", price: 1.29, checked: false },
    { name: "Beef Broth", amount: 1, unit: "carton", aisle: "Pantry", price: 2.99, checked: false },
    
    // Fresh Herbs
    { name: "Fresh Rosemary", amount: 1, unit: "pack", aisle: "Produce", price: 2.49, checked: false },
    { name: "Fresh Dill", amount: 1, unit: "bunch", aisle: "Produce", price: 1.99, checked: false },
    { name: "Fresh Parsley", amount: 1, unit: "bunch", aisle: "Produce", price: 1.49, checked: false },
    { name: "Fresh Thyme", amount: 1, unit: "pack", aisle: "Produce", price: 2.49, checked: false },
    { name: "Fresh Cilantro", amount: 1, unit: "bunch", aisle: "Produce", price: 0.99, checked: false },
  ],
  stats: {
    total_items: 31,
    checked_items: 2,
    estimated_total: 112.87,
    items_by_aisle: {
      "Meat & Seafood": 5,
      "Produce": 15,
      "Dairy": 3,
      "Pantry": 7,
      "Bakery": 1
    }
  }
};

// Demo savings calculations
export const DEMO_SAVINGS = {
  this_week: {
    estimated_cost: 112.87,
    typical_unplanned_cost: 165.00,
    savings: 52.13,
    savings_percent: 32,
    meals_planned: 6,
    servings: 26,
    cost_per_serving: 4.34,
    restaurant_equivalent: 312.00,  // 26 servings * $12 avg
    vs_restaurant_savings: 199.13
  },
  cumulative: {
    weeks_using_carted: 8,
    total_saved: 417.04,
    meals_planned: 48,
    hours_saved: 16,
    food_waste_prevented_lbs: 12
  },
  insights: [
    {
      type: "overlap",
      message: "Smart overlap! Chicken and garlic used in 2 meals.",
      savings: 3.50
    },
    {
      type: "bulk",
      message: "Buying 3 lbs of protein saves vs. individual purchases.",
      savings: 4.20
    },
    {
      type: "seasonal",
      message: "Asparagus is in season - great pick!",
      savings: 2.00
    }
  ]
};

// Demo user profile
export const DEMO_USER = {
  name: "Demo User",
  email: "demo@carted.app",
  preferences: {
    household_size: 4,
    dietary_restrictions: [],
    cuisine_preferences: ["American", "Mediterranean"],
    cooking_skill: "intermediate",
    weekly_budget: 150
  },
  stats: {
    plans_created: 8,
    lists_exported: 6,
    favorite_recipes: 12
  }
};

// Demo paths for selection
export const DEMO_PATHS = [
  {
    id: "weeknight-healthy",
    name: "Weeknight Healthy",
    description: "Quick, nutritious meals for busy families",
    emoji: "🥗",
    meals_per_week: 5,
    avg_prep_time: 25,
    tags: ["30-min meals", "balanced", "family-friendly"]
  },
  {
    id: "budget-friendly",
    name: "Budget Friendly",
    description: "Delicious meals that won't break the bank",
    emoji: "💰",
    meals_per_week: 6,
    avg_prep_time: 30,
    tags: ["under $10/meal", "bulk cooking", "pantry staples"]
  },
  {
    id: "meal-prep-master",
    name: "Meal Prep Master",
    description: "Cook once, eat all week",
    emoji: "📦",
    meals_per_week: 5,
    avg_prep_time: 45,
    tags: ["batch cooking", "freezer-friendly", "time-saver"]
  }
];

// Helper to get demo data
export const getDemoMealPlan = () => DEMO_MEAL_PLAN;
export const getDemoGroceryList = () => DEMO_GROCERY_LIST;
export const getDemoSavings = () => DEMO_SAVINGS;
export const getDemoUser = () => DEMO_USER;
export const getDemoPaths = () => DEMO_PATHS;

// Calculate totals
export const calculateDemoTotals = () => {
  const list = DEMO_GROCERY_LIST;
  const uncheckedItems = list.items.filter(i => !i.checked);
  const total = uncheckedItems.reduce((sum, item) => sum + (item.price || 0), 0);
  
  return {
    subtotal: total.toFixed(2),
    items_to_buy: uncheckedItems.length,
    pantry_items_skipped: list.items.filter(i => i.checked).length,
    estimated_savings: DEMO_SAVINGS.this_week.savings.toFixed(2)
  };
};
